import { render, staticRenderFns } from "./QuestionType8.vue?vue&type=template&id=b094d858&scoped=true"
import script from "./QuestionType8.vue?vue&type=script&lang=js"
export * from "./QuestionType8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b094d858",
  null
  
)

export default component.exports